// ./src/contexts/NotesContext/NotesContext.tsx
//
// Thin context wrapper around the useNotes hook. All derived data lives in the
// hook itself. See PointsOfInterestContext for the pattern.

import React, { createContext, useContext } from "react";

import { useNotes, UseNotesOptions, UseNotesReturn } from "@/hooks/useNotes";

const NotesContext = createContext<UseNotesReturn | null>(null);

export interface NotesProviderProps extends UseNotesOptions {
  children: React.ReactNode;
}

export const NotesProvider: React.FC<NotesProviderProps> = ({ children, ...options }) => {
  const value = useNotes(options);

  return <NotesContext.Provider value={value}>{children}</NotesContext.Provider>;
};

export const useNotesContext = (): UseNotesReturn => {
  const context = useContext(NotesContext);

  if (!context) {
    throw new Error(
      "useNotesContext must be used within a <NotesProvider>. " +
        "Wrap your component tree with <NotesProvider> to fix this."
    );
  }

  return context;
};

export const useOptionalNotesContext = (): UseNotesReturn | null => {
  return useContext(NotesContext);
};
